import React, { useState } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — Champ mot de passe avec toggle afficher/masquer.
 * 
 * RÈGLE GLOBALE : Tout champ password du site utilise ce composant.
 * - État par défaut : masqué
 * - Icône Eye/EyeOff pour basculer
 * - Accessible (aria-label, bouton clavier, pas de submit)
 * - Ne modifie jamais la valeur transmise
 * 
 * Props : identiques à <Input>, transmises via rest props.
 */
const PasswordInput = React.forwardRef(({ className = '', ...props }, ref) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible(v => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
